import * as React from "react";
/**
 * The icon representing an Excel file
 */ export const ExcelFile = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M7.5 22H21.5C21.775 22 22 21.775 22 21.5V7H18.5C17.673 7 17 6.327 17 5.5V2H7.5C7.225 2 7 2.225 7 2.5V21.5C7 21.775 7.225 22 7.5 22Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M21.293 6.00003L18 2.70703V5.50003C18 5.77503 18.225 6.00003 18.5 6.00003H21.293Z",
        fill: "white"
    }), /*#__PURE__*/ React.createElement("path", {
        opacity: "0.67",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.56 5.854L18.146 1.439C17.8642 1.15891 17.4833 1.00117 17.086 1H7.5C6.673 1 6 1.673 6 2.5V21.5C6 22.327 6.673 23 7.5 23H21.5C22.327 23 23 22.327 23 21.5V6.914C23 6.514 22.844 6.137 22.56 5.854ZM18 2.707L21.293 6H18.5C18.2241 5.99945 18.0006 5.77591 18 5.5V2.707ZM7.5 22H21.5C21.775 22 22 21.775 22 21.5V7H18.5C17.673 7 17 6.327 17 5.5V2H7.5C7.225 2 7 2.225 7 2.5V21.5C7.00055 21.7759 7.22409 21.9995 7.5 22Z",
        fill: "#605E5C"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19 17H18C17.4477 17 17 16.5523 17 16C17 15.4477 17.4477 15 18 15H19C19.5523 15 20 15.4477 20 16C20 16.5523 19.5523 17 19 17Z",
        fill: "#134A2C"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 17H14V15H15C15.5523 15 16 15.4477 16 16C16 16.5523 15.5523 17 15 17Z",
        fill: "#185C37"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19 14H18C17.4477 14 17 13.5523 17 13C17 12.4477 17.4477 12 18 12H19C19.5523 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14Z",
        fill: "#21A366"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 14H14V12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14Z",
        fill: "#107C41"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19 11H18C17.4477 11 17 10.5523 17 10C17 9.44772 17.4477 9 18 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11Z",
        fill: "#33C481"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15 11H14V9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11Z",
        fill: "#21A366"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M2 19H12C12.5523 19 13 18.5523 13 18V8C13 7.44772 12.5523 7 12 7H2C1.44772 7 1 7.44772 1 8V18C1 18.5523 1.44772 19 2 19Z",
        fill: "#107C41"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.125 16L6.185 12.991L4.298 10H5.816L6.846 11.913C6.941 12.093 7.006 12.229 7.042 12.318H7.056C7.123 12.173 7.194 12.033 7.269 11.896L8.369 10H9.763L7.827 12.974L9.813 16H8.329L7.139 13.9C7.08337 13.8111 7.03585 13.7174 6.997 13.62H6.98C6.94493 13.7155 6.89861 13.8065 6.842 13.891L5.617 16H4.125Z",
        fill: "#F9F7F7"
    }));
